import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	popoverContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		minWidth: 280,
		padding: THEME.spacing.md,
	},
	resultList: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		maxHeight: 240,
		overflowY: 'auto',
	},
	resultItem: {
		alignItems: 'center',
		background: 'none',
		border: 'none',
		borderRadius: THEME.common.borderRadius,
		cursor: 'pointer',
		display: 'flex',
		justifyContent: 'flex-start',
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		textAlign: 'left',
		width: '100%',
		':hover': {
			background: THEME.colors.background.main,
		},
	},
	statusText: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
	},
});
